export const onGetResponseLoadingOrder = (responseData, itemsResponseRouteOrder) => {
    const createGoodsArray = [];
        responseData.forEach((el, index) => {
            const findElem = itemsResponseRouteOrder.find((el, i) => i === index)
            if(findElem !== undefined) {
                const goodsArr = {...findElem, id: el.data.id}
                createGoodsArray.push(goodsArr)
                }
            })
            return onGetGoodsForRequestAddForLoadingOrder(createGoodsArray.flat());
        }

const onGetGoodsForRequestAddForLoadingOrder = (itemsResponseRouteOrder) => {
    const createGoodsArray = [];
    itemsResponseRouteOrder.forEach(el => {
        const goodsArr = el.goods.map(function(item) {
            return {...item, id: el.id}
        })
        createGoodsArray.push(goodsArr)
    })
    return createGoodsArray.flat()
}
